import { publicPath } from '../publicPath';

export type HomePartnerLogo = {
  id: string;
  name: string;
  imageSrc: string;
  /**
   * Scale inside the fixed circle (default 1). Use >1 to zoom in when the PNG has
   * large empty margins; use <1 when the artwork is clipped by the circle.
   */
  imageScale?: number;
  /** Circle fill behind the logo (default white). */
  circleBackground?: string;
};

/** Partner brands on the home logo carousel — files under `/partner-logos/`. */
export const HOME_PARTNER_LOGOS: HomePartnerLogo[] = [
  { id: 'mixer', name: 'MIXER Work & Lounge', imageSrc: publicPath('/partner-logos/mixer.png'), imageScale: 0.86 },
  { id: 'dogether', name: 'dogether', imageSrc: publicPath('/partner-logos/dogether.png'), imageScale: 1.38 },
  { id: 'sok', name: 'SOK', imageSrc: publicPath('/partner-logos/sok.png'), imageScale: 1.48 },
  { id: 'urban-place', name: 'Urban Place', imageSrc: publicPath('/partner-logos/urban-place.png'), imageScale: 1.28 },
  {
    id: 'point-azrieli',
    name: 'PO!NT by Azrieli',
    imageSrc: publicPath('/partner-logos/point-azrieli.png'),
    imageScale: 1.56,
    circleBackground: '#000000',
  },
  { id: 'be-all', name: 'BE ALL', imageSrc: publicPath('/partner-logos/be-all.png'), imageScale: 1.52 },
  {
    id: 'port-ashtrom',
    name: 'Port by Ashtrom',
    imageSrc: publicPath('/partner-logos/port-ashtrom.png'),
    imageScale: 1.4,
  },
  { id: 'hubz', name: 'hubz', imageSrc: publicPath('/partner-logos/hubz.png'), imageScale: 1.38 },
  { id: 'mindspace', name: 'MINDSPACE', imageSrc: publicPath('/partner-logos/mindspace.png'), imageScale: 1.34 },
  { id: 'wework', name: 'WeWork', imageSrc: publicPath('/partner-logos/wework.png'), imageScale: 1.5 },
  { id: 'regus', name: 'Regus', imageSrc: publicPath('/partner-logos/regus.png'), imageScale: 1.36 },
  { id: 'rooms', name: 'ROOMS', imageSrc: publicPath('/partner-logos/rooms.png'), imageScale: 1.48 },
];
